export default {
	save: "Salva",
	cancel: "Annulla",
	ok: "OK",
	change: "Modifica",
};
